<template>
  <div class="s-disclaimer" v-if="field && field.value">
    <template v-if="disclaimer">
      <div
        class="s-disclaimer__main"
        v-html="$formatString(field.value, { disclaimer: disclaimer?.fields?.icon?.value?.alt })"
        @click="(e) => iconClick(e, disclaimer)"
      ></div>
    </template>
    <template v-else>
      <JssRichText :field="field" />
    </template>
  </div>
</template>
<script>
import { inject } from 'vue';

export default {
  name: 'Disclaimer',
  props: {
    field: {
      type: Object,
    },
    disclaimer: {
      type: Object,
    },
  },
  setup(props) {
    const toast = inject('toast');
    const methods = {
      iconClick: (e, i) => {
        e.stopPropagation();
        toast.show({
          icon: 'levc',
          message: i.fields.text.value,
          closable: true,
        });
      },
    };
    return {
      ...methods,
    };
  },
};
</script>
<style lang="scss">
.s-disclaimer {
  &__main {
    cursor: pointer;
    > div,
    span,
    p {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
    }
  }
}
</style>
